import { render, staticRenderFns } from "./orderApproveCreate.vue?vue&type=template&id=2b911fa4&scoped=true"
import script from "./orderApproveCreate.vue?vue&type=script&lang=js"
export * from "./orderApproveCreate.vue?vue&type=script&lang=js"
import style0 from "./orderApproveCreate.vue?vue&type=style&index=0&id=2b911fa4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b911fa4",
  null
  
)

export default component.exports